module.exports = __webpack_public_path__ + "static/media/realtimetext-bold.8b12b243.woff";